module.exports = __webpack_public_path__ + "public/23f8c0d44fe48df549a2e59dea602119.ttf";